export function getAbsoluteOffset(el) {
  if (!el) {
    return { top: 0, left: 0 };
  }
  let rect = el.getBoundingClientRect();
  return { top: rect.top + (window.pageYOffset || 0), left: rect.left + (window.pageXOffset || 0) };
}
